import { render, staticRenderFns } from "./FlexCompanyMetric.vue?vue&type=template&id=07f8ed54&lang=pug&"
import script from "./FlexCompanyMetric.vue?vue&type=script&lang=ts&"
export * from "./FlexCompanyMetric.vue?vue&type=script&lang=ts&"
import style0 from "./FlexCompanyMetric.vue?vue&type=style&index=0&id=07f8ed54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports